import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
  .course-filter {
    background: ${colors.bg2};
    padding: 62px 0 70px;

    .sec-title {
      h4 {
        color: ${colors.black1};
        line-height: 35px;
        font-weight: 600;
        max-width: 550px;
        margin: auto;
        margin-bottom: 42px;

        @media (max-width: 575px) {
          margin-bottom: 15px;
          font-size: 20px;
        }
      }
    }

    .category-heading {
      text-align: center;
      margin-bottom: 30px;

      .category-btn {
        background: #fff;
        border: 1px solid ${colors.border1};
        color: ${colors.text3};
        font-size: 14px;
        font-weight: 500;
        border-radius: 5px;
        padding: 6px 16px;
        margin: 5px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          border-color: ${colors.red};
          color: ${colors.red};
          background: rgba(0, 128, 0, 0.04);
        }

        &.active {
          background: ${colors.red};
          color: #fff;
          border-color: ${colors.red};
        }
      }

      @media (max-width: 767px) {
        overflow-x: auto;
        white-space: nowrap;
        padding-bottom: 8px;

        .category-btn {
          display: inline-block;
        }
      }
    }

    .categories-wrapper {
      display: flex;
      flex-direction: column;
      gap: 45px;
    }

    .category-block {
      .category-heading {
        margin-bottom: 25px;
        text-align: left;

        h5 {
          font-size: 20px;
          font-weight: 600;
          color: ${colors.black1};
          position: relative;
          padding-left: 18px;

          &:before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 6px;
            height: 20px;
            border-radius: 3px;
            background: ${colors.red};
          }
        }
      }

      .course-item {
        border: 1px solid ${colors.border1};
        border-radius: 5px;
        transition: all 0.2s ease;
        background: #ffffff;
        margin-bottom: 30px;

        .course-content {
          padding: 20px 25px;

          h6.heading {
            a {
              color: ${colors.black1};
              font-weight: 600;
              display: inline-block;
              margin-bottom: 12px;

              &:hover {
                color: ${colors.red};
              }
            }
          }

          .course-price {
            p {
              font-size: 16px;
              color: ${colors.red};
              font-weight: 600;
              margin: 0;
            }
          }

          p.desc {
            font-size: 14px;
            color: ${colors.text3};
            line-height: 25px;
            border-bottom: 1px solid ${colors.border1};
            padding-bottom: 12px;
            margin-bottom: 15px;
          }

          .course-face {
            display: flex;
            flex-wrap: wrap;
            gap: 10px 15px;

            > div {
              flex: 1 1 30%;

              p {
                display: inline-flex;
                align-items: center;
                gap: 6px;
                font-size: 13px;
                color: ${colors.text3};
                margin: 0;

                i {
                  font-size: 16px;
                  color: ${colors.red};
                }
              }
            }
          }

          .course-actions {
            display: flex;
            align-items: center;
            gap: 12px;

            .btn {
              font-size: 12px;
              font-weight: 500;
              padding: 6px 12px;
            }

            .btn-link {
              color: ${colors.red};
              font-weight: 600;

              &:hover {
                color: ${colors.red2};
              }
            }
          }
        }

        &:hover {
          box-shadow: 0 12px 25px rgba(0, 0, 0, 0.07);
        }
      }
    }

    .viewall-btn {
      a {
        font-size: 15px;
        color: #fff;
        background: ${colors.red_bg};
        display: inline-block;
        width: 200px;
        height: 48px;
        text-transform: uppercase;
        font-weight: 500;
        text-align: center;
        padding: 14px;
        border-radius: 5px;
        margin-top: 20px;

        &:hover {
          background: ${colors.red_bg2};
        }

        @media (max-width: 575px) {
          font-size: 13px;
          width: 170px;
          height: 42px;
          padding: 12px;
          margin-top: 10px;
        }
      }
    }

    @media (max-width: 767px) {
      padding: 25px 0 40px;
    }
  }
`;
